import { supplierContactName } from './contact-name';
import { supplierContactPhone } from './contact-phone';
import { supplierAddressColumn } from './supplier-address';
import { supplierCountry } from './supplier-country';
import { supplierEmailColumn } from './supplier-email';
import { createSupplierNameColumn } from './supplier-name';
import { supplierGridProperties } from '../../data/suppliers-properties';

/**
 * Creates the base column configuration for the suppliers grid
 * Returns a map of column property names to their column configurations
 * @returns Object mapping supplier grid property names to column configurations
 */
export function createBaseColumns() {
  return {
    [supplierGridProperties.supplierName]: createSupplierNameColumn(),
    [supplierGridProperties.supplierEmail]: supplierEmailColumn,
    [supplierGridProperties.supplierAddress]: supplierAddressColumn,
    [supplierGridProperties.supplierCountry]: supplierCountry,
    [supplierGridProperties.contactName]: supplierContactName,
    [supplierGridProperties.contactPhone]: supplierContactPhone,
  };
}
